type KeySelector<T> = keyof T | ((item: T) => PropertyKey);
type ValueSelector<T, V> = keyof T | ((item: T) => V);

// Перегрузки для точного вывода типов
export function arrayIndex<T>(
    array: readonly T[],
    keyField: KeySelector<T>
): Record<string, T>;

export function arrayIndex<T, K extends keyof T>(
    array: readonly T[],
    keyField: KeySelector<T>,
    valueField: K
): Record<string, T[K]>;

export function arrayIndex<T, V>(
    array: readonly T[],
    keyField: KeySelector<T>,
    valueField: (item: T) => V
): Record<string, V>;

// Реализация
export function arrayIndex<T>(
    array: readonly T[],
    keyField: KeySelector<T>,
    valueField?: ValueSelector<T, any>
): Record<string, any> {
    return array.reduce((acc, item) => {
        // Извлекаем ключ
        const key = typeof keyField === 'function'
            ? keyField(item)
            : item[keyField];

        if (key == null) return acc;
        const keyStr = String(key);

        // Извлекаем значение
        let value: any;
        if (valueField === undefined) {
            value = item;
        } else if (typeof valueField === 'function') {
            value = valueField(item);
        } else {
            value = item[valueField];
        }

        acc[keyStr] = value;
        return acc;
    }, {} as Record<string, any>);
}
